<template>
  <div class="admin-gradebook-container">
    <div class="grid-container">
      <div class="admin-gradebook">
        <table class="admin-gradebook-table">
          <thead>
            <tr>
              <!--              <th><div></div></th>-->
              <th v-for="header in tableHeaders" :key="header">{{ header }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lender in lenders" :key="lender.id">
              <!--              <td>-->
              <!--              <img-->
              <!--                  v-if="lender.user.image || lender.user.errorImage"-->
              <!--                  @error="() => (lender.user.errorImage = true)"-->
              <!--                  :src="lender.user.image"-->
              <!--                  alt=""-->
              <!--              />-->
              <!--              Logo-->
              <!--              </td>-->
              <td @click="openModal(lender)" :class="$style.lenderName">
                {{ lender.name }}
              </td>
              <td @click="openModal(lender)">
                {{ `${lender.city}, ${lender.state}` }}
              </td>
              <td @click="openModal(lender)">
                {{ lender.representative }}
              </td>
              <td @click="openModal(lender)">
                {{ lender.phone }}
              </td>
              <td @click="openModal(lender)">
                {{ lender.email }}
              </td>
              <td @click="openModal(lender)">
                {{ lender.createdAtFormatted }}
              </td>
              <td>
                <div
                  :class="$style.pendingParent"
                  v-if="lender.lenderStatusId === 1"
                >
                  <div :class="$style.pending">Signup Incomplete</div>
                </div>
                <div
                  v-else-if="lender.lenderStatusId === 4"
                  :class="$style.approveWrapper"
                  @click="handleApproveLender(lender.id)"
                >
                  <div :class="$style.airlines">Approve</div>
                </div>
                <div v-else :class="$style.activeWrapper">
                  <div :class="$style.airlines">Active</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="loading" class="loading">
          <b-spinner
            label="Loading..."
            variant="primary"
            class="spinner"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div :class="$style.frameChild31" />
    <HiloAdminDashboardLenderInfo
      v-if="modalOpen"
      :object="modalObject"
      @close="closeModal"
    />
  </div>
</template>
<script>
import HiloAdminDashboardLenderInfo from "../../HiloAdminDashboardLenderInfo.vue";
import LenderAPIService from "@/servicehandlers/LenderAPIService.js";
import UsersAPIService from "@/servicehandlers/UsersAPIService.js";
const lenderAPIService = new LenderAPIService();
const usersAPIService = new UsersAPIService();
import dayjs from "dayjs";

export default {
  components: {
    HiloAdminDashboardLenderInfo,
  },
  data() {
    return {
      loading: false,
      tableHeaders: [
        "Name",
        "Location",
        "Representative",
        "Phone Number",
        "Email",
        "Created",
        "Status",
      ],
      lenders: null,
      modalOpen: false,
      modalObject: [],
    };
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      await this.getLenders();
      await this.getLenderReps();
      this.loading = false;
    },
    async getLenders() {
      return lenderAPIService
        .getLenders()
        .then((response) => {
          this.lenders = response.map((lender) => ({
            ...lender,
            createdAtFormatted: dayjs(lender.createdAt).format("MM/DD/YYYY"),
          }));
        })
        .catch(() => {});
    },
    async getLenderReps() {
      for (let lender of this.lenders) {
        let lenderRep = await usersAPIService.getLenderRepByLenderId(lender.id);
        lender.representative = `${lenderRep.firstName} ${lenderRep.lastName}`;
      }
    },
    async handleApproveLender(lenderId) {
      let lender = await lenderAPIService.getLendersById(lenderId);
      lender.lenderStatusId = 7;
      await lenderAPIService.updateLenders(lenderId, lender);
      await this.loadData();
    },
    openModal(data) {
      this.modalObject = data;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
  },
};
</script>
<style scoped module>
.airlines {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: white;
}
.lenderName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;
}
.activeWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: #00a551;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}
.approveWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: #3c78ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}
.pending {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pendingParent {
  flex: 1;
  width: 100%;
  position: relative;
  border-radius: 5px;
  background-color: #e5e5e5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  box-sizing: border-box;
  text-align: left;
  font-size: 15px;
  color: #8e8e8e;
  font-family: Helvetica, Arial, sans-serif;
}
.loading {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.admin-gradebook-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.grid-container {
  display: grid;
  align-items: center;
  place-items: center;
  gap: 10px;
  box-sizing: border-box;
}
.grid-container h1 {
  font-weight: 600;
  font-size: 25px;
  margin-top: 10px;
}
.admin-gradebook {
  width: 100%;
  display: grid;
}
.admin-gradebook-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.admin-gradebook-table td {
  border: 1px solid #ddd;
  padding: 4px 8px;
  text-align: left;
}
.admin-gradebook-table th {
  background-color: rgba(60, 120, 255, 1);
  color: white;
  font-weight: 400;
  padding: 5px 10px;
}
.admin-gradebook-table th:first-child {
  border-top-left-radius: 10px;
}
.admin-gradebook-table th:last-child {
  border-top-right-radius: 10px;
}
.admin-gradebook-table th:first-child {
  width: 30px;
}
.admin-gradebook-table th:first-child div {
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
}
.admin-gradebook-table img {
  height: 25px;
  width: 25px;
  border-radius: 5px;
}
.activeWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: #00a551;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}
.frameChild31 {
  width: 100px;
  position: relative;
  background-color: #f6f6f6;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 0;
}
</style>
